export const lastNonNull = (arr, fallback)=>{
    for(let i = arr.length - 1; i >= 0; i--){
        if (arr[i] !== null) return arr[i];
    }
    return fallback;
};

//# sourceMappingURL=lastNonNull.js.map